<template>
    <div id="course">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="head">
                <i class="back"
                   @click="back()"></i>
                <p class="title">作业详情</p>
                <p class="preview"
                   @click="preview()">作业预览</p>
            </div>
            <div class="list">
                <div class="list_warp">
                    <div class="list_item">

                    </div>
                </div>
            </div>
            <template>
                <div class="rate">
                    <div>
                        <h3>{{stuData.unit_score_rate}}<span>%</span></h3>
                        <p>平均分</p>
                    </div>
                    <div>
                        <h3>{{stuData.good_score_rate}}<span>%</span></h3>
                        <p>优秀率</p>
                    </div>
                    <div>
                        <h3>{{stuData.pass_score_rate}}<span>%</span></h3>
                        <p>及格率</p>
                    </div>
                </div>
                <div class="tab">
                    <p :class="{'active':type==1}"
                       @click="tab(1)">按学生查看</p>
                    <p :class="{'active':type==2}"
                       @click="tab(2)">试题错误率</p>
                    <p :class="{'active':type==3}"
                       @click="tab(3)">知识点掌握率</p>
                </div>
                <stu v-if="type==1&&Object.keys(stuData).length"
                     :stuData="stuData"
                     :unitId="unitId"
                     :sid="sid"
                     :cid="cid"
                     :gradeAverage="gradeAverage"></stu>
                <wrong v-if="type==2"
                       :sid="sid"
                       :cid="cid"
                       :unitId="unitId"></wrong>
                <knowledge v-if="type==3"
                           :sid="sid"
                           :cid="cid"
                           :unitId="unitId"></knowledge>
            </template>
            <div :class='["bottom_btn","bottom_btn2"]'>
                <div class='bottom_btn-box'>
                    <div class="bottom_btn-div share"
                         @click="share">
                        <p>分享报告给家长</p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import headers from "COMPONENTS/base/header.vue";
import loadings from "COMPONENTS/base/loadingS.vue";
import knowledge from "./module/course_knowledge.vue";
import stu from "./module/course_stu.vue";
import wrong from "./module/course_wrong.vue";
export default {
    components: {
        loadings,
        headers,
        stu,
        knowledge,
        wrong
    },
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            status: 0,
            type: 1,
            listClass: [{
                name: '总览',
                id: 0,
                on: true
            }],
            option: {
                grid: {
                    left: '0.5rem',
                    right: '-13%',
                    bottom: '3%',
                    containLabel: true
                },
                legend: {
                    selectedMode: false,
                    data: ['班级平均', '年级平均'],
                    right: '1%'
                },
                xAxis: [{
                    type: 'category',
                    data: [],
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '10' //更改坐标轴文字大小
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    // name: '班级平均',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }, {
                    type: 'value',
                    // name: '年级平均',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }],
                series: []
            },
            legend: {
                0: ['班级平均', '年级平均'],
                1: ['班级优秀率', '年级平均优秀率'],
                2: ['班级合格率', '年级平均合格率']
            },
            sid: this.$route.query.sid,
            cid: this.$route.query.cid,
            gradeId: this.$route.query.gradeId,
            unit_class_id: this.$route.query.cid,
            unitId: 2921295,
            data: {
                0: [
                    [],
                    []
                ],
                1: [
                    [],
                    []
                ],
                2: [
                    [],
                    []
                ]
            },
            xData: [],
            stuData: {}, //按学生查看数据
            echartStyle: {
                width: '15rem',
                height: '10.5rem'
            },
            fromPath: '',
            fromData: {},
            gradeAverage: null, //年级平均
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // 通过 `vm` 访问组件实例,将值传入fromPath
            vm.fromPath = from.path;
            vm.fromData = from.query;
        })
    },
    computed: {
        fromChild () {
            let formC = false;
            if (this.fromPath.indexOf('task/stuDetail') >= 0 || this.fromPath.indexOf('task/taskDetail') >= 0 ||
                this.fromPath.indexOf('task/knowledgDetail') >= 0) {
                formC = true;
            }
            return formC;
        },
    },
    created () {

    },
    mounted () {
        this.getClassData(this.gradeId)
        let data = {
            sid: this.sid,
            cid: this.cid,
            grade_id: this.gradeId
        }
        this.$http.post(API_URL_ZNZY_API + '/tea/catalog_detail/', data).then(d => {
            d = d.data;
            this.loading = false;
            if (d.response == 'ok') {
                //作业得分
                d.data.task_rate.score_rate.forEach((e) => {
                    let o = {
                        name: e.unit_name,
                        id: e.unit_class_id,
                        on: false
                    }
                    this.data['0'][0].push(e.unit_score);
                    this.data['0'][1].push(d.data.task_rate.unit_average);
                    this.listClass.push(o)
                    this.xData.push(e.unit_name);
                })
                this.gradeAverage = d.data.task_rate.unit_average;
                if (this.xData.length) {
                    let n = Math.ceil(this.xData.length / 5);
                    this.echartStyle.width = Number(15 * n) + 'rem';
                }
                d.data.task_good_rate.score_rate.forEach((e) => {
                    this.data['1'][0].push(e.unit_score);
                    this.data['1'][1].push(d.data.task_rate.unit_average);
                })
                d.data.task_pass_rate.score_rate.forEach((e) => {
                    this.data['2'][0].push(e.unit_score);
                    this.data['2'][1].push(d.data.task_rate.unit_average);
                })
                if (!this.fromChild) {
                    this.$nextTick(() => {
                        //this.initChart();
                    })
                } else {
                    this.fromChildSetData();
                }
            } else {
                layer.tips(d.data.message);
            }
        });
    },
    methods: {
        preview () {
            //作业预览
            if (this.task_type == 1) {
                this.$router.push('/english/read_preview/' + this.sid + '/' + this.message_id + '/' + this.task_type);
            } else {
                this.$router.push('/english/preview/' + this.sid + '/' + this.message_id + '/' + this.task_type);
            }
        },
        initChart () {
            // let chart = document.getElementById("chart");
            this.option.xAxis[0].data = this.xData;
            for (let i = 0; i < 3; i++) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById("main" + i));
                this.option.legend.data = this.legend[i];
                this.option.series = this.setSeriesData(i);
                myChart.setOption(this.option);
            }
        },
        setSeriesData (num) {
            let array = this.legend[num];
            let color = ['#3c7cfb', '#4ecb39', '#ffaf5a']
            let series = [{
                name: array[0],
                type: 'bar',
                label: {
                    show: true,
                    position: 'top'
                },
                itemStyle: {
                    color: color[num]
                },
                data: this.data[num][0]
            }, {
                name: array[1],
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                    color: '#8cd33b'
                },
                data: this.data[num][1]
            }];
            return series;
        },

        tab (type) {
            this.type = type;
        },
        getClassData (id) {
            let data = {
                sid: this.sid,
                cid: this.cid,
                unit_class_id: id
            };
            // this.$store.commit("setLoading",true);
            this.$http.post(API_URL_ZNZY_API + '/tea/catalog_unit_detail/', data).then(d => {
                if (d.data.response == 'ok') {
                    d = d.data;
                    this.stuData = d.data;
                } else {
                    layer.tips(d.data.message);
                }
            })
            // .finally(()=>{
            //     this.$store.commit("setLoading",false);
            // })
        },
        fromChildSetData () {
            this.unitId = this.fromData.unitId;
            this.status = 1;
            this.listClass.forEach((l, i) => {
                if (l.id == this.unitId) {
                    l.on = true;
                } else {
                    l.on = false;
                }
                this.listClass.splice(i, 1, l);
            });
            //console.log(this.unitId, this.fromData)
            if (this.fromPath.indexOf('task/stuDetail') >= 0) {
                this.type = 1;
            } else if (this.fromPath.indexOf('task/taskDetail') >= 0) {
                this.type = 2;
            } else {
                this.type = 3;
            }

        },
        share () {
            let url = `${VUE_URL_HD}/#/chinese/inspect/course/?cid=${this.cid}&sid=${this.sid}&gradeId=${this.gradeId}&title=${this.title}`;
            if (this.inApp) {
                //console.log("APP分享")
                let title = this.unit_class_name + "完成情况";
                let content = this.unit_class_name + (this.sid == 21 ? "数学" : "语文") + "暑假作业完成情况";
                this.appFunction("ys_share", `${title},${content},${url},2,${this.unit_class_id},0,5,暑假活动评测作业分享`);
                //console.log(url);
            } else {
                //console.log("微信分享")
                let coptText = `家长您好，${this.title}的作业报告已生成，点击链接即可查看，链接：${url}`;
                this.copyText(coptText);
                this.copyVisible = true;
                layer.alert('分享链接复制成功', 'tea', function (index) {
                    layer.close(index)
                })
            }

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 30px / $ppr;
        left: 24px / $ppr;
        width: 18px / $ppr;
        height: 34px / $ppr;
        background: url(./img/choose_back.png) no-repeat;
        background-size: 100% 100%;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 30px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
#course {
    padding-bottom: 30px / $ppr;
    width: 100%;
    overflow-x: hidden;
}

.list {
    // width:660px/$ppr;
    width: 100%;
    margin: 0 auto;
    height: 20px / $ppr;
    position: relative;
}

.box {
    width: 600px / $ppr;
    margin: 0 auto 30px / $ppr;
    background: #fff;
    padding: 25px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;

    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;

        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("./img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}

.rate {
    width: 690px / $ppr;
    margin: 0 auto;
    margin-bottom: 20px / $ppr;
    margin-top: 96px / $ppr;
    display: flex;
    justify-content: space-between;

    div {
        background-image: linear-gradient(#fff, #f7f8f9);
        width: 220px / $ppr;
        text-align: center;
        padding: 30px / $ppr 0 50px / $ppr;

        &:nth-child(1) {
            h3 {
                color: #3c7cfb;
            }
        }

        &:nth-child(2) {
            h3 {
                color: #4ecb39;
            }
        }

        &:nth-child(3) {
            h3 {
                color: #ffaf5a;
            }
        }

        h3 {
            line-height: 66px / $ppr;
            font-size: 56px / $ppr;
            font-weight: bold;

            span {
                font-size: 32px / $ppr;
                font-weight: normal;
            }
        }

        p {
            font-size: 24px / $ppr;
            color: #999;
        }
    }
}

.tab {
    width: 544px / $ppr;
    height: 54px / $ppr;
    margin: 0 auto;
    border: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    border-radius: 28px / $ppr;

    p {
        // float: left;
        width: 180px / $ppr;
        line-height: 54px / $ppr;
        font-size: 24px / $ppr;
        color: #888;
        text-align: center;

        &:nth-child(1) {
            border-top-left-radius: 28px / $ppr;
            border-bottom-left-radius: 28px / $ppr;
        }

        &:nth-child(2) {
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;
        }

        &:nth-child(3) {
            border-top-right-radius: 28px / $ppr;
            border-bottom-right-radius: 28px / $ppr;
        }

        &.active {
            background: #e7f4ff;
            color: #0f8fff;
        }
    }
}

.white_bg {
    background: #fff;
}

.dighol_span_number {
}

.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}

.bottom_btn1 {
    .bottom_btn-div {
        width: 50%;
    }
}
.bottom_btn2 {
    .bottom_btn-div {
        width: 100%;
    }
}

.bottom_btn {
    width: 100%;
    height: 80px / $ppr;
    margin-top: 25px / $ppr;
    .bottom_btn-box {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        background: #fff;

        padding: 20px / $ppr 32px / $ppr;
    }
    .share {
        background: #5e89ef;
        border-radius: 80px / $ppr;
        overflow: hidden;
    }
    .reward {
        background: #ff6600;
    }
    .reward,
    .share {
        color: #fff;
        p {
            text-align: center;
            margin: 0 auto;
            line-height: 80px / $ppr;
            // padding-left:50px/$ppr;
            position: relative;
        }
        img {
            display: inline-block;
            position: relative;
            width: 40px / $ppr;
            top: 8px / $ppr;
            margin-right: 10px / $ppr;
        }
    }
}
</style>